import React from 'react'
import { Link } from 'react-router-dom'

import PropTypes from 'prop-types'

import './footer.css'

const Footer = (props) => {
  return (
    <div className={`footer-thq-footer-elm ${props.rootClassName} `}>
      <div className="footer-thq-content-elm">
        <div className="footer-thq-information-elm">
          <div className="footer-thq-heading-elm">
            <Link to="/" className="footer-navlink">
              <img
                alt={props.imageAlt11}
                src={props.imageSrc11}
                className="footer-image1"
              />
            </Link>
            <span className="footer-text1">{props.text1}</span>
          </div>
          <div className="footer-thq-socials-elm">
            <a
              href="https://www.instagram.com/romania/"
              target="_blank"
              rel="noreferrer noopener"
            >
              <div className="footer-thq-social-elm1">
                <svg
                  viewBox="0 0 877.7142857142857 1024"
                  className="footer-icon1"
                >
                  <path d="M585.143 512c0-80.571-65.714-146.286-146.286-146.286s-146.286 65.714-146.286 146.286 65.714 146.286 146.286 146.286 146.286-65.714 146.286-146.286zM664 512c0 124.571-100.571 225.143-225.143 225.143s-225.143-100.571-225.143-225.143 100.571-225.143 225.143-225.143 225.143 100.571 225.143 225.143zM725.714 277.714c0 29.143-23.429 52.571-52.571 52.571s-52.571-23.429-52.571-52.571 23.429-52.571 52.571-52.571 52.571 23.429 52.571 52.571zM438.857 152c-64 0-201.143-5.143-258.857 17.714-20 8-34.857 17.714-50.286 33.143s-25.143 30.286-33.143 50.286c-22.857 57.714-17.714 194.857-17.714 258.857s-5.143 201.143 17.714 258.857c8 20 17.714 34.857 33.143 50.286s30.286 25.143 50.286 33.143c57.714 22.857 194.857 17.714 258.857 17.714s201.143 5.143 258.857-17.714c20-8 34.857-17.714 50.286-33.143s25.143-30.286 33.143-50.286c22.857-57.714 17.714-194.857 17.714-258.857s5.143-201.143-17.714-258.857c-8-20-17.714-34.857-33.143-50.286s-30.286-25.143-50.286-33.143c-57.714-22.857-194.857-17.714-258.857-17.714zM877.714 512c0 60.571 0.571 120.571-2.857 181.143-3.429 70.286-19.429 132.571-70.857 184s-113.714 67.429-184 70.857c-60.571 3.429-120.571 2.857-181.143 2.857s-120.571 0.571-181.143-2.857c-70.286-3.429-132.571-19.429-184-70.857s-67.429-113.714-70.857-184c-3.429-60.571-2.857-120.571-2.857-181.143s-0.571-120.571 2.857-181.143c3.429-70.286 19.429-132.571 70.857-184s113.714-67.429 184-70.857c60.571-3.429 120.571-2.857 181.143-2.857s120.571-0.571 181.143 2.857c70.286 3.429 132.571 19.429 184 70.857s67.429 113.714 70.857 184c3.429 60.571 2.857 120.571 2.857 181.143z"></path>
                </svg>
              </div>
            </a>
            <a
              href="https://www.facebook.com/romania/"
              target="_blank"
              rel="noreferrer noopener"
            >
              <div className="footer-thq-social-elm2">
                <svg viewBox="0 0 1024 1024" className="footer-icon3">
                  <path d="M608 192h160v-192h-160c-123.514 0-224 100.486-224 224v96h-128v192h128v512h192v-512h160l32-192h-192v-96c0-17.346 14.654-32 32-32z"></path>
                </svg>
              </div>
            </a>
            <a
              href="https://www.tiktok.com/@romania"
              target="_blank"
              rel="noreferrer noopener"
            >
              <div className="footer-thq-social-elm3">
                <div className="footer-container1">
                  <img
                    alt={props.imageAlt1}
                    src={props.imageSrc3}
                    className="footer-image2"
                  />
                </div>
              </div>
            </a>
            <a
              href="https://www.linkedin.com/company/romania/"
              target="_blank"
              rel="noreferrer noopener"
            >
              <div className="footer-thq-social-elm4">
                <svg
                  viewBox="0 0 877.7142857142857 1024"
                  className="footer-icon5"
                >
                  <path d="M199.429 357.143v566.286h-188.571v-566.286h188.571zM211.429 182.286c0.571 54.286-40.571 97.714-106.286 97.714v0h-1.143c-63.429 0-104-43.429-104-97.714 0-55.429 42.286-97.714 106.286-97.714 64.571 0 104.571 42.286 105.143 97.714zM877.714 598.857v324.571h-188v-302.857c0-76-27.429-128-95.429-128-52 0-82.857 34.857-96.571 68.571-4.571 12.571-6.286 29.143-6.286 46.286v316h-188c2.286-513.143 0-566.286 0-566.286h188v82.286h-1.143c24.571-38.857 69.143-95.429 170.857-95.429 124 0 216.571 81.143 216.571 254.857z"></path>
                </svg>
              </div>
            </a>
          </div>
        </div>
        <div className="footer-thq-links-elm">
          <div className="footer-thq-column-elm1">
            <span className="footer-thq-header-elm">{props.header111}</span>
            <a
              href="mailto:hi@romania.org.ro?subject=Hi @Romania!"
              className="footer-link5"
            >
              <div className="footer-container2">
                <svg viewBox="0 0 1024 1024" className="footer-icon7">
                  <path d="M128 337.963l359.552 251.691c14.507 10.027 33.92 10.496 48.939 0l359.509-251.691v430.037c0 11.605-4.693 22.229-12.587 30.080s-18.475 12.587-30.080 12.587h-682.667c-11.605 0-22.229-4.693-30.080-12.587s-12.587-18.475-12.587-30.080zM42.667 256.512v511.488c0 35.328 14.507 67.371 37.547 90.453s55.125 37.547 90.453 37.547h682.667c35.328 0 67.371-14.507 90.453-37.547s37.547-55.125 37.547-90.453v-511.488c0-0.427 0-0.853 0-1.28-0.213-35.029-14.635-66.773-37.547-89.685-23.083-23.040-55.125-37.547-90.453-37.547h-682.667c-35.328 0-67.371 14.507-90.453 37.547-22.912 22.912-37.333 54.656-37.547 89.728 0 0.213 0 0.469 0 0.725zM891.477 236.971l-379.477 265.6-379.477-265.6c2.048-4.096 4.779-7.808 8.021-11.051 7.893-7.893 18.517-12.587 30.123-12.587h682.667c11.605 0 22.229 4.693 30.080 12.587 3.243 3.243 5.973 6.997 8.021 11.051z"></path>
                </svg>
                <span className="footer-thq-link-elm1">{props.link1011}</span>
              </div>
            </a>
          </div>
          <div className="footer-thq-column-elm2">
            <Link to="/ambassadors" className="footer-thq-link-elm2">
              {props.link101}
            </Link>
            <a
              href="https://www.500k.ro/"
              target="_blank"
              rel="noreferrer noopener"
              className="footer-thq-link-elm3"
            >
              {props.link1022}
            </a>
            <a
              href="https://www.stramosi.com/"
              target="_blank"
              rel="noreferrer noopener"
              className="footer-thq-link-elm4"
            >
              {props.link10211}
            </a>
            <a
              href="https://romaniapass.io/"
              target="_blank"
              rel="noreferrer noopener"
              className="footer-thq-link-elm5"
            >
              {props.link102112}
            </a>
            <Link to="/founders" className="footer-thq-link-elm6">
              {props.link1021111}
            </Link>
          </div>
        </div>
      </div>
      <div className="footer-container3">
        <span className="footer-text2">{props.text}</span>
        <span className="footer-text3">{props.text2}</span>
      </div>
      <img
        alt={props.imageAlt21}
        src={props.imageSrc21}
        className="footer-image3"
      />
    </div>
  )
}

Footer.defaultProps = {
  imageSrc3: '/socials/tiktok.svg',
  link102112: 'RomaniaPASS',
  link1011: 'hi@romania.org.ro',
  imageAlt11: 'image',
  text2: 'Located at 67 Unirii Blvd.',
  imageAlt1: 'image',
  imageSrc11: '/logo/romania_logo.svg',
  link101: 'Ambassadors',
  rootClassName4: '',
  text1: 'Experience the raw beauty of Romania',
  header111: 'Stay in touch',
  rootClassName: '',
  imageSrc21: '/r.svg',
  imageAlt21: 'image',
  link1022: 'Contribute',
  rootClassName2: '',
  text: '©2026 @Romania NGO. All Rights Reserved.',
  link1021111: 'Founders',
  link10211: 'Stramosi',
  rootClassName1: '',
}

Footer.propTypes = {
  imageSrc3: PropTypes.string,
  link102112: PropTypes.string,
  link1011: PropTypes.string,
  imageAlt11: PropTypes.string,
  text2: PropTypes.string,
  imageAlt1: PropTypes.string,
  imageSrc11: PropTypes.string,
  link101: PropTypes.string,
  rootClassName4: PropTypes.string,
  text1: PropTypes.string,
  header111: PropTypes.string,
  rootClassName: PropTypes.string,
  imageSrc21: PropTypes.string,
  imageAlt21: PropTypes.string,
  link1022: PropTypes.string,
  rootClassName2: PropTypes.string,
  text: PropTypes.string,
  link1021111: PropTypes.string,
  link10211: PropTypes.string,
  rootClassName1: PropTypes.string,
}

export default Footer
